module.exports = __webpack_public_path__ + "img/20191128165828714.e5c63a41.jpg";